// Room templates for different property types
export const PROPERTY_TEMPLATES = {
  studio: ['Pokój główny', 'Łazienka', 'Aneks kuchenny'],
  '1-bedroom': ['Salon', 'Sypialnia', 'Kuchnia', 'Łazienka', 'Korytarz'],
  '2-bedroom': ['Salon', 'Sypialnia 1', 'Sypialnia 2', 'Kuchnia', 'Łazienka', 'Korytarz'],
  '3-bedroom': ['Salon', 'Sypialnia 1', 'Sypialnia 2', 'Sypialnia 3', 'Kuchnia', 'Łazienka 1', 'Łazienka 2', 'Korytarz'],
  house: ['Salon', 'Sypialnia 1', 'Sypialnia 2', 'Sypialnia 3', 'Kuchnia', 'Łazienka 1', 'Łazienka 2', 'Piwnica', 'Garaż', 'Ogród'],
};

// Standard items to check in each room
export const ROOM_ITEMS = {
  common: [
    'Ściany (stan farby/tapet)',
    'Sufit',
    'Podłoga',
    'Drzwi',
    'Okna',
    'Parapety',
    'Grzejniki',
    'Kontakty elektryczne',
    'Oświetlenie',
  ],
  Kuchnia: [
    'Ściany (stan farby/tapet)',
    'Sufit',
    'Podłoga',
    'Drzwi',
    'Okna',
    'Szafki kuchenne (fronty)',
    'Blat kuchenny',
    'Zlew i bateria',
    'Lodówka',
    'Kuchenka/piekarnik',
    'Okap',
    'Płytki ścienne',
    'Kontakty elektryczne',
  ],
  'Łazienka': [
    'Płytki ścienne',
    'Płytki podłogowe',
    'Wanna/prysznic',
    'Umywalka',
    'Toaleta',
    'Baterie',
    'Lustro',
    'Wentylacja',
    'Drzwi',
    'Sufit',
  ],
  'Łazienka 1': [
    'Płytki ścienne',
    'Płytki podłogowe',
    'Wanna/prysznic',
    'Umywalka',
    'Toaleta',
    'Baterie',
    'Lustro',
    'Wentylacja',
    'Drzwi',
    'Sufit',
  ],
  'Łazienka 2': [
    'Płytki ścienne',
    'Płytki podłogowe',
    'Wanna/prysznic',
    'Umywalka',
    'Toaleta',
    'Baterie',
    'Lustro',
    'Wentylacja',
    'Drzwi',
    'Sufit',
  ],
};

// Condition ratings for inspection items
export const CONDITIONS = {
  excellent: { label: 'Doskonały', color: '#10b981', icon: '✨' },
  good: { label: 'Dobry', color: '#3b82f6', icon: '✓' },
  fair: { label: 'Średni', color: '#f59e0b', icon: '⚠' },
  poor: { label: 'Zły', color: '#ef4444', icon: '✕' },
};

// Inspection types
export const INSPECTION_TYPES = {
  'move-in': { label: 'Wprowadzenie', color: '#10b981' },
  'periodic': { label: 'Okresowa', color: '#3b82f6' },
  'move-out': { label: 'Wyprowadzka', color: '#ef4444' },
};

// Property type labels
export const PROPERTY_TYPE_LABELS = {
  studio: 'Kawalerka',
  '1-bedroom': 'Mieszkanie 2 pokojowe',
  '2-bedroom': 'Mieszkanie 3 pokojowe',
  '3-bedroom': 'Mieszkanie 4 pokojowe',
};

// Helper function to get items for a room
export const getRoomItems = (roomName) => {
  // Check if room has specific items
  if (ROOM_ITEMS[roomName]) {
    return ROOM_ITEMS[roomName];
  }
  // Otherwise return common items
  return ROOM_ITEMS.common;
};

// Rental status labels
export const RENTAL_STATUS = {
  available: { label: 'Dostępna', color: '#10b981', icon: '🏠' },
  rented: { label: 'Wynajęta', color: '#64748b', icon: '🔑' },
  maintenance: { label: 'W remoncie', color: '#f59e0b', icon: '🔧' },
  archived: { label: 'Archiwum', color: '#6b7280', icon: '📦' },
};

// Lease status labels
export const LEASE_STATUS = {
  active: { label: 'Aktywna', color: '#10b981', icon: '✓' },
  ended: { label: 'Zakończona', color: '#6b7280', icon: '○' },
  terminated: { label: 'Rozwiązana', color: '#ef4444', icon: '✕' },
  archived: { label: 'Archiwum', color: '#94a3b8', icon: '📦' },
};

// Currency labels
export const CURRENCIES = {
  PLN: { label: 'PLN (zł)', symbol: 'zł' },
  EUR: { label: 'EUR (€)', symbol: '€' },
  USD: { label: 'USD ($)', symbol: '$' },
  GBP: { label: 'GBP (£)', symbol: '£' },
};

// Countries dictionary (sync with database countries table)
export const COUNTRIES = [
  { code: 'PL', name: 'Polska' },
  { code: 'DE', name: 'Niemcy' },
  { code: 'CZ', name: 'Czechy' },
  { code: 'SK', name: 'Słowacja' },
  { code: 'UA', name: 'Ukraina' },
  { code: 'AT', name: 'Austria' },
  { code: 'FR', name: 'Francja' },
  { code: 'GB', name: 'Wielka Brytania' },
  { code: 'ES', name: 'Hiszpania' },
  { code: 'IT', name: 'Włochy' },
  { code: 'NL', name: 'Holandia' },
  { code: 'BE', name: 'Belgia' },
  { code: 'CH', name: 'Szwajcaria' },
  { code: 'SE', name: 'Szwecja' },
  { code: 'NO', name: 'Norwegia' },
  { code: 'DK', name: 'Dania' },
  { code: 'FI', name: 'Finlandia' },
  { code: 'IE', name: 'Irlandia' },
  { code: 'PT', name: 'Portugalia' },
  { code: 'GR', name: 'Grecja' },
  { code: 'HU', name: 'Węgry' },
  { code: 'RO', name: 'Rumunia' },
  { code: 'BG', name: 'Bułgaria' },
  { code: 'HR', name: 'Chorwacja' },
  { code: 'SI', name: 'Słowenia' },
  { code: 'LT', name: 'Litwa' },
  { code: 'LV', name: 'Łotwa' },
  { code: 'EE', name: 'Estonia' },
];

// Document types
export const DOCUMENT_TYPES = {
  contract: { label: 'Umowa najmu', icon: '📄' },
  insurance: { label: 'Ubezpieczenie', icon: '🛡️' },
  certificate: { label: 'Certyfikat', icon: '✓' },
  other: { label: 'Inny dokument', icon: '📎' },
};

// Helper function to get property type label in Polish
export function getPropertyTypeLabel(type) {
  return PROPERTY_TYPE_LABELS[type] || type;
}

// Helper function to format full property address
export function formatPropertyAddress(property) {
  const parts = [];

  // Street + building number/apartment number
  if (property.street && property.building_number) {
    let addressLine = `${property.street} ${property.building_number}`;
    if (property.apartment_number) {
      addressLine += `/${property.apartment_number}`;
    }
    parts.push(addressLine);
  }

  // Postal code + city
  if (property.postal_code && property.city) {
    parts.push(`${property.postal_code} ${property.city}`);
  } else if (property.city) {
    parts.push(property.city);
  }

  // Country (only if not Poland)
  if (property.country_code && property.country_code !== 'PL') {
    const country = COUNTRIES.find(c => c.code === property.country_code);
    parts.push(country ? country.name : property.country_code);
  }

  return parts.join(', ');
}

// Helper function to get country name by code
export function getCountryName(countryCode) {
  const country = COUNTRIES.find(c => c.code === countryCode);
  return country ? country.name : countryCode;
}

// Helper function to create initial inspection structure
export const createInspectionStructure = (propertyType, inspectionType, property) => {
  const rooms = PROPERTY_TEMPLATES[propertyType] || PROPERTY_TEMPLATES['1-bedroom'];

  return {
    type: inspectionType,
    property: property,
    propertyId: property.id,
    date: new Date().toISOString().split('T')[0],
    inspector: '',
    overallNotes: '',
    rooms: rooms.map((roomName, roomIndex) => ({
      roomName,
      items: getRoomItems(roomName).map((itemName, itemIndex) => ({
        name: itemName,
        condition: 'good',
        notes: '',
        photos: [],
      })),
    })),
  };
};
